import type { IconDef } from '../types';

export const play: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M16.4498 11.0094L8.84211 6.18789C8.47129 5.95212 8.00478 5.94033 7.62201 6.14074C7.23923 6.34114 7 6.74195 7 7.17813V16.8211C7 17.2573 7.23923 17.6463 7.62201 17.8585C7.80144 17.9528 7.99282 18 8.19617 18C8.42344 18 8.65072 17.9411 8.84211 17.8114L16.4498 12.9899C16.7966 12.7777 17 12.4004 17 11.9996C17 11.5988 16.7966 11.2216 16.4498 11.0094Z',
    },
  ],
};
